import { ECheckDailyrentPriceActionTypes } from 'shared/actions/checkDailyrentPrice/types';
import { EDailyrentBookingCalendarActionTypes } from 'shared/actions/dailyrentBookingCalendar/types';
import { IDailyrentBookingGeneralState } from 'shared/store/dailyrentBookingParams/types';
import { IOfferData } from 'shared/types/offerData';
import { RootAction } from 'shared/types/redux/RootAction';

const initialState: IDailyrentBookingGeneralState = {
  isLoading: false,
  isOnlineBooking: false,
  paymentSummary: undefined,
  priceInfo: undefined,
  defaultBookingMessage: '',
  error: '',
  tripId: undefined,
};

export const dailyrentBookingGeneralReducer = (
  state: IDailyrentBookingGeneralState = initialState,
  action: RootAction,
): IDailyrentBookingGeneralState => {
  switch (action.type) {
    case 'IOfferFetched': {
      const {
        offer: { dailyrent },
      } = action.offerData as IOfferData;

      const paymentSummary = dailyrent?.paymentSummary || undefined;
      const isOnlineBooking = dailyrent?.isOnlineBooking || false;
      const onlineBookingMessage = dailyrent?.onlineBookingMessage || '';

      return {
        ...state,
        isOnlineBooking,
        tripId: dailyrent?.tripId,
        defaultBookingMessage: onlineBookingMessage,
        paymentSummary,
        priceInfo: dailyrent?.priceInfo || undefined,
      };
    }
    case ECheckDailyrentPriceActionTypes.Loading:
    case EDailyrentBookingCalendarActionTypes.SetAvailabilityLoading:
      return { ...state, isLoading: action.payload };
    case ECheckDailyrentPriceActionTypes.Success:
      return {
        ...state,
        defaultBookingMessage: action.payload.onlineBookingMessage || '',
        paymentSummary: action.payload.paymentSummary || undefined,
        priceInfo: action.payload.priceInfo,
        tripId: action.payload.tripId,
        error: '',
      };
    case EDailyrentBookingCalendarActionTypes.SetError:
    case ECheckDailyrentPriceActionTypes.Fail:
      return { ...state, error: action.payload };
    case EDailyrentBookingCalendarActionTypes.SetDates: {
      const { from, to } = action.payload;

      if (from !== undefined || to !== undefined) {
        return state;
      }

      return {
        ...state,
        defaultBookingMessage: '',
        paymentSummary: undefined,
        priceInfo: undefined,
        error: '',
      };
    }
    default:
      return state;
  }
};
